import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction"
import { CalendarConstant } from '../../actions/constants/CalendarConstant';
import { CalendarAction } from '../../actions';
import ScheduleCreate from '../../components/schedule/ScheduleCreate';
import { DEFAULT_SCHEDULE_HOURS } from '../../config/scheduleDefaults';
import { Translate as t } from '../../config/Translate';
import { LoadingOverlay } from '../../components/common/LoadingOverlay';

const LANG_TO_FC_LOCALE = {
    kor: 'ko', jpn: 'ja', deu: 'de', spa: 'es', fre: 'fr', ita: 'it',
    cmn: 'zh-cn', zhh: 'zh-tw', slk: 'sk', pol: 'pl', ron: 'ro',
    ces: 'cs', por: 'pt', swe: 'sv', ell: 'el', tur: 'tr', rus: 'ru', kaz: 'kk',
};

const getCalendarLocale = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return LANG_TO_FC_LOCALE[user.rguardSettingLanguage] || 'en';
    } catch (e) {
        return 'en';
    }
};

const AdminCalendar = ({ items, isLoading, GetList }) => {

    const [month, setMonth] = useState(moment().format("YYYY-MM-DD"))
    const [sched, setSched] = useState([])
    const [showAS, setShowAS] = useState(false);
    const [height, setHeight] = useState(window.innerHeight - 240);
    const dispatch = useDispatch();

    useEffect(() => {
        window.onresize = updateHeight;
    }, [])

    useEffect(() => {
        const arr = []
        items.map(x => {
            arr.push({
                id: x._id,
                title: (x.title ? "[" + x.title + "]" : "") + (x.sitename ? x.sitename : ''),
                start: x.start,
                end: x.finish
            })
        })
        setSched(arr);
    }, [items])


    const updateHeight = () => {
        setHeight(window.innerHeight - 200);
    }

    const changedMonth = (e) => {
        const start = moment.utc(e.start).valueOf();
        const end = moment.utc(e.end).valueOf();
        GetList({
            start: { '$gte': start, '$lte': end },
        });
    }

    const selectSche = (e) => {
        const f = items.filter(x => x._id == e.event.id);
        if (f.length > 0) {
            dispatch({ type: CalendarConstant.SET_NEW, item: f[0] });
            setShowAS(true);
        }
    }

    const ASNew = (e) => {
        dispatch({
            type: CalendarConstant.SET_NEW, item: {
                type: "Pre-install",
                color: "bg-warning",
                start: moment(e.date).clone().valueOf(),
                finish: moment(e.date).clone().add(DEFAULT_SCHEDULE_HOURS, "hours").valueOf()
            }
        });
        setShowAS(true);
    }

    return (
        <>
            <div className="extraHeader pb-0">
                <h2 className="mb-0">{t('installation.calendar.title')}</h2>
                <div className="ray-right">
                </div>
            </div>
            <div id="appCapsule" className="extra-header-active full-height pb-0" style={{ background: "white" }}>
                <div className="section mt-1 mb-1" style={{ position: 'relative' }}>
                    <LoadingOverlay show={isLoading} />
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        dayMaxEvents={true}
                        initialDate={month}
                        contentHeight={height}
                        eventColor={"black"}
                        dateClick={e => ASNew(e)}
                        eventClick={e => selectSche(e)}
                        eventTimeFormat={{
                            hour: 'numeric',
                            minute: '2-digit',
                            meridiem: 'short'
                        }}
                        initialView="dayGridMonth"
                        datesSet={e => changedMonth(e)}
                        events={sched}
                        locale={getCalendarLocale()}
                        buttonText={{ today: t('common.label.today') }}
                    />
                    <ScheduleCreate isFull={false} showAS={showAS} callback={() => setShowAS(false)} />
                </div>
            </div>
        </>
    )
}

const mapState = (state) => {
    const items = state.CalendarReducer.items;
    const isLoading = state.CalendarReducer.isLoading;
    return { items, isLoading };
}

const mapDispatch = dispatch => ({
    GetList: (filter) => dispatch(CalendarAction.GetAllByFilter(filter)),
})

export default connect(mapState, mapDispatch)(AdminCalendar);
